import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCharacterDetailRequest, getCharacterFavorite, getCharacterRequest } from "./../../../pages/Character/redux/actions"

export const useCharacterFavorite = (params) => {
  const dispatch = useDispatch();
  const { favorites } = useSelector(state => state.characterReducers);

  useEffect(() => {
    dispatch(getCharacterFavorite(params));
  }, [params, dispatch, getCharacterFavorite]);

  return [favorites]
};


export const useCharacter = (params) => {
  const dispatch = useDispatch();
  const { character } = useSelector(state => state.characterReducers);

  useEffect(() => {
    dispatch(getCharacterRequest(params));
  }, [params, dispatch, getCharacterRequest]);

  return [character]
};

export const useCharacterDetail = (params) => {
  const dispatch = useDispatch();
  const { characterDetail, isProcessingDetail } = useSelector(state => state.characterReducers);

  useEffect(() => {
    dispatch(getCharacterDetailRequest(params));
  }, [params, dispatch, getCharacterRequest]);

  return [characterDetail, isProcessingDetail]
};